import Color from 'color';

/** Our own color class that we can extend with more functions as we need  */
export class ThemeColor {

    private color: Color;

    constructor(value: string | ThemeColor) {
        this.color = typeof value === 'string' ? Color(value) : value.color;
    }

    hex(): string {
        if (this.color.alpha() === 1) {
            return this.color.hex().toLowerCase();
        } else {
            return this.color.rgb().string();
        }
    }

    negate(): ThemeColor {
        this.color = this.color.negate();
        return this;
    }

    lighten(ratio: number): ThemeColor {
        this.color = this.color.lighten(ratio);
        return this;
    }

    darken(ratio: number): ThemeColor {
        this.color = this.color.darken(ratio);
        return this;
    }

    saturate(ratio: number): ThemeColor {
        this.color = this.color.saturate(ratio);
        return this;
    }

    desaturate(ratio: number): ThemeColor {
        this.color = this.color.desaturate(ratio);
        return this;
    }

    whiten(ratio: number): ThemeColor {
        this.color = this.color.whiten(ratio);
        return this;
    }

    blacken(ratio: number): ThemeColor {
        this.color = this.color.blacken(ratio);
        return this;
    }

    grayscale(): ThemeColor {
        this.color = this.color.grayscale();
        return this;
    }

    fade(ratio: number): ThemeColor {
        this.color = this.color.fade(ratio);
        return this;
    }

    opaquer(ratio: number): ThemeColor {
        this.color = this.color.opaquer(ratio);
        return this;
    }

    rotate(degrees: number): ThemeColor {
        this.color = this.color.rotate(degrees);
        return this;
    }

    // YIQ luminance, the measure Color.isDark() uses, with the threshold exposed because the two
    // callers need different ones. 128 suits text on a page background. Text on a saturated fill
    // needs a higher threshold: #5cb85c scores 146 and #5bc0de 165, so at 128 both are classed
    // light and take dark text, alongside a near-white at 245.
    inverse(light: string, dark: string, threshold = 128): ThemeColor {
        const [r, g, b] = this.color.rgb().array();
        return (r * 299 + g * 587 + b * 114) / 1000 < threshold ? new ThemeColor(light) : new ThemeColor(dark);
    }

}
